export class User {

    constructor(props) {
        Object.assign(this, {...props});
        this.channel = `App.User.${this.id}`;
    }

    can = (permission) => {
        return this.permissions.indexOf(permission) >= 0;
    };

    hasRole = (role) => {

        if (this.selected_role) {
            //check first role
            return this.roles[0] === role;
        } else {
            // check in all roles
            return this.roles.indexOf(role) >= 0;
        }

    };

}
